"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DURATION_MODIFIER = void 0;
// eslint-disable-next-line import/prefer-default-export
const DURATION_MODIFIER = 3;
exports.DURATION_MODIFIER = DURATION_MODIFIER;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEVVJBVElPTl9NT0RJRklFUiJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FuaW1hdGlvbnMvQW5pbWF0aW9ucy5jb25zdHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGltcG9ydC9wcmVmZXItZGVmYXVsdC1leHBvcnRcbmV4cG9ydCBjb25zdCBEVVJBVElPTl9NT0RJRklFUiA9IDNcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFDTyxNQUFNQSxpQkFBaUIsR0FBRyxDQUExQiJ9